import { render, staticRenderFns } from "./VoipRecorder.vue?vue&type=template&id=6052d248&"
import script from "./VoipRecorder.vue?vue&type=script&lang=js&"
export * from "./VoipRecorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports